/**
 * Messages EN de l'éditeur de template de charte graphique
 */

module.exports = {

    mobileWarning: {
        title: 'Your browser window is too small!',
        description: 'Tookano is only accessible on your laptop or desktop computer. The browser window width must be at least 992px.'
    },

    watermarkMessage: 'The Tookano watermark on the image, which protects copyrights, will disappear once published on your social networks. Similarly, the image resolution is automatically adjusted for broadcast.',

    node: {
        text: {
            defaultText: 'Write your text here'
        },
        publicationImageInformationNodeText: 'Dynamic image automatically generated based on the subject'
    },

    lateralMenu: {
        design: {
            label: 'Graphic Model'
        },
        text: {
            label: 'Text'
        },
        shape: {
            label: 'Shape',
        },
        brand: {
            label: 'Brand'
        },
        media: {
            label: 'Media'
        }
    },

    sidePanel: {
        design: {
            title: 'Graphic model',
            tabMenu: {
                single: 'Single Image',
                carousel: 'Carousel'
            },
            buttons: {
                addCharter: {
                    single: 'Add a template',
                    carousel: 'Add a template'
                },
                manageThemes: 'Content Types'
            },
            manageThemes: {
                description: 'Manage content types to associate a template with this content.'
            },
            templateList: {
                title: 'All Templates'
            }
        },
        text: {
            title: 'Text',
            buttons: {
                addText: 'Add a text area'
            },
            dynamicText: {
                title: 'Predefined Dynamic Texts',
                tooltip: 'Dynamic text is a text area whose content will be automatically generated by AI, varying for each post, based on the provided prompt.',
                types: {
                    heading: 'Add a heading',
                    subheading: 'Add a subheading',
                    description: 'Add body text'
                },
                parameters: {
                    title: 'Customize my prompt',
                    fields: {
                        prompt: {
                            label: 'Describe the prompt to be used for generating your content.',
                            placeholder: 'For example: "A catchy headline summarizing the post" or: "A Call to Action title to drive traffic to my website"'
                        },
                        maxCharacters: {
                            label: 'Number of characters:'
                        },
                        contentType: {
                            label: 'Type',
                            default: 'Select a type',
                            options: {
                                heading1: 'Heading',
                                heading2: 'Subheading',
                                description: 'Description'
                            }
                        }
                    },
                    buttons: {
                        addNode: 'Add dynamic text',
                        updateNode: 'Edit dynamic text'
                    }
                }
            }
        },
        shape: {
            title: 'Shapes',
            baseShapes: {
                title: 'Basic Shapes'
            },
            baseLines: {
                title: 'Basic Lines'
            },
            customerShapes: {
                title: 'My shapes',
                edit: {
                    form: {
                        error: 'An error occurred while saving the shape.',
                        fieldset: {
                            shape: {
                                title: 'Shape { position }'
                            }
                        },
                        fields: {
                            name: 'Shape name',
                            file: 'Shape file',
                        }
                    },
                    modal: {
                        titleWithName: '{ shape } edition',
                        titleWithoutName: 'Shape edition'
                    },
                    button: {
                        edit: {
                            altLabel: 'Edit the shape.'
                        }
                    }
                },
                add: {
                    modal: {
                        title: 'Add a shape',
                        form: {
                            button: {
                                addAnotherShape: {
                                    label: 'Add another shape'
                                }
                            }
                        }
                    },
                    button: {
                        add: {
                            label: 'Add a shape'
                        }
                    }
                },
            },
            svgShapes: {
                title: 'Other shapes'
            }
        },
        brand: {
            title: 'Brand',
            buttons: {
                goToAccount: {
                    label: 'Configure your brand'
                }
            },
            logo: {
                title: 'Logo',
                additionalLogo: {
                    error: 'An error occurred while uploading the logo.'
                },
                buttons: {
                    add: {
                        label: 'Add a logo'
                    }
                },
                uploadLogo: {
                    error: 'An error occurred while updating the logo.'
                }
            },
            colors: {
                title: 'Color Palette',
                updateColors: {
                    error: 'An error occurred while updating the colors.'
                }
            },
            fonts: {
                title: 'Typography',
                buttons: {
                    add: {
                        heading1: {
                            label: 'Add typography for titles'
                        },
                        heading2: {
                            label: 'Add typography for subtitles'
                        },
                        description: {
                            label: 'Add typography for descriptions'
                        }
                    }
                }
            }
        },
        media: {
            title: 'Media',
            library: {
                title: {
                    label: 'Your images',
                    tooltip: 'Download your images. They will automatically be given priority in the Suggested Images if the subject of a post matches one of them. This will save you a lot of time.'
                },
                empty: 'No images found.'
            },
            imagesBank: {
                title: {
                    label: 'Image Bank',
                    tooltip: 'These are images from a partner. The licensing rights for use on your social networks are included in your subscription.'
                }
            },
            dynamicImages: {
                title: 'Dynamic Images',
                description: 'A dynamic image is a visual that will automatically change based on the post topic.',
                preview: {
                    title: 'Dynamic Image',
                    description: 'Visual generated automatically based on the subject'
                }
            },
            aiImages: {
                title: {
                    label: 'AI Images',
                    tooltip: 'Select an image and ask the AI to change elements on the image. Or select no image and ask the AI to create a new image from a new prompt.'
                },
                error: 'An error occurred while generating images.',
                prompt: {
                    placeholder: 'Describe the image you want.'
                },
                legalMessage: 'The images below are generated by artificial intelligence',
                buttons: {
                    search: {
                        label: 'Search'
                    }
                },
                enrichPrompt: 'Ask AI to enrich your prompt'
            },

            suggestedMedias: {
                title: {
                    label: 'Suggested Media',
                    tooltip: 'This is a suggestion of images related to the idea of the post'
                }
            },

            buttons: {
                addMedias: {
                    label: 'Upload media'
                },
                importImage: {
                    label: 'Upload an image'
                }
            }
        }
    },

    content: {
        header: {
            defaultTemplateName: 'Graphic Template Name',
            save: {
                error: 'An error occurred during saving'
            },
            exit: {
                confirmation: {
                    message: 'Are you sure you want to close the editor?',
                    buttons: {
                        save: 'Save and exit',
                        exit: 'Exit without saving'
                    }
                }
            }
        },
        toolbar: {
            background: {
                altLabel: 'Background'
            },
            opacity: {
                altLabel: 'Transparency',
                label: 'Transparency'
            },
            rotation: {
                altLabel: 'Flip and rotate',
                label: 'Rotation',
                return: {
                    label: 'Flip',
                    horizontal: 'Horizontally',
                    vertical: 'Vertically'
                },
                rotate: {
                    label: 'Rotate',
                    toLeft: 'Rotate left 90°',
                    toRight: 'Rotate right 90°'
                }
            },
            depth: {
                title: 'Arrange',
                altLabel: 'Arrange',
                moveUp: 'Move forward',
                moveDown: 'Move backward',
                moveFront: 'Move to front',
                moveBack: 'Move to back'
            },
            align: {
                title: 'Align on page',
                altLabel: 'Align',
                top: 'Top',
                left: 'Left',
                center: 'Center',
                bottom: 'Bottom',
                right: 'Right'
            },
            shape: {
                background: {
                    altLabel: 'Background'
                },
                border: {
                    altLabel: 'Border Style',
                    width: {
                        title: 'Border thickness'
                    },
                    radius: {
                        title: 'Corner radius'
                    },
                    color: {
                        altLabel: 'Border color'
                    }
                },
                mask: {
                    altLabel: 'Mask: makes the shape transparent'
                }
            },
            text: {
                fontFamily: {
                    title: 'Typography',
                    buttons: {
                        add: {
                            label: 'Add a font'
                        }
                    }
                },
                fontSize: {
                    altLabel: 'Font size'
                },
                color: {
                    altLabel: 'Text color'
                },
                bold: {
                    altLabel: 'Bold'
                },
                italic: {
                    altLabel: 'Italic'
                },
                underline: {
                    altLabel: 'Underline'
                },
                align: {
                    altLabel: 'Alignment',
                    menu: {
                        horizontal: {
                            title: 'Horizontal',
                            types: {
                                left: 'Left',
                                center: 'Center',
                                right: 'Right',
                                justify: 'Justify'
                            }
                        },
                        vertical: {
                            title: 'Vertical',
                            types: {
                                top: 'Top',
                                middle: 'Middle',
                                bottom: 'Bottom'
                            }
                        },
                    }
                },
                spacing: {
                    altLabel: 'Spacing',
                    letter: {
                        label: 'Letter spacing'
                    },
                    lineHeight: {
                        label: 'Line height'
                    }
                }
            },
            svg: {
                color: {
                    altLabel: 'Background color of the shape'
                }
            },
            remove: {
                altLabel: 'Remove'
            },
            duplicate: {
                altLabel: 'Duplicate'
            },
            lock: {
                altLabel: 'Lock'
            }
        },

        color: {
            societyColors: {
                title: 'Brand Colors'
            },
            recentColor: {
                label: 'Recent Color'
            },
            customerColorIndex: {
                none: 'None',
                primary: 'Primary',
                secondary: 'Secondary',
                tertiary: 'Tertiary'
            },
            fields: {
                customerColorIndex: 'Client Color'
            }
        },

        background: {
            menu: {
                none: 'None',
                color: 'Solid',
                gradient: 'Gradient'
            },

            addColor: {
                label: 'Add Color'
            },

            gradient: {
                fields: {
                    percent: 'From'
                }
            }
        },

        layer: {
            remove: {
                confirmation: {
                    message: 'Are you sure you want to remove this item?'
                },
                all: {
                    label: 'Remove all'
                }
            }
        },
        children: {
            defaultName: 'Page { position }',
            remove: {
                confirmation: {
                    message: 'Are you sure you want to delete this page?'
                }
            }
        },

        contextualMenu: {
            button: {
                group: {
                    label: 'Group'
                },
                ungroup: {
                    label: 'Ungroup'
                }
            }
        }
    }

};
